export const CONTACT_RULE: ValidationRule = {
  id: 'jps-contact',
  strict: true,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'ID',
        en: ''
      }
    },
    type: {
      field: 'type',
      type: 'string',
      mandatory: true,
      enumKey: 'jps-contact_type',
      label: {
        ja: 'お問い合わせの種別',
        en: 'Type'
      }
    },
    name: {
      field: 'name',
      type: 'string',
      mandatory: true,
      label: {
        ja: 'お名前',
        en: 'Name'
      }
    },
    affiliation: {
      field: 'affiliation',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'ご所属',
        en: 'Organization'
      }
    },
    email: {
      field: 'email',
      type: 'string',
      mandatory: true,
      label: {
        ja: '電子メールアドレス',
        en: 'Email Address'
      }
    },
    content: {
      field: 'content',
      type: 'string',
      mandatory: true,
      allowMultiline: true,
      label: {
        ja: '具体的な内容',
        en: 'Contents'
      }
    }
  }
  , enums: {
    'jps-contact_type': CONTACT_TYPE_DEF
  }
}
